import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Ucretlendirme1 from "./Payment1";

const UcretlendirmeMain = () => {
  return (
    <div>
      <Navbar />

      <Ucretlendirme1 />
      <Footer />
    </div>
  );
};

export default UcretlendirmeMain;
